import { createReducer } from '@reduxjs/toolkit';
import { clearPaymentData, resetPaymentUserData, updatePaymentData } from '../actions/payments';
import { requestFail, requestPending, requestSuccess } from '../../utils/status';
import {
  GET_BUILDING_ONBOARDING_STATUS,
  GET_BUILDING_PAYMENT_STATS,
  GET_ORGANIZATION_ONBOARDING_STATUS,
  GET_VOPAY_USER,
  GET_VOPAY_USER_PAYMENT_METHODS
} from '../constants';

const initialState = {
  selectedBuilding: undefined,
  userId: undefined,

  paymentOption: undefined,

  startDate: undefined,
  endDate: undefined,

  amount: undefined,
  frequency: 'monthly',
  notes: undefined,

  accountNumber: undefined,
  bankTransitNumber: undefined,
  institutionNumber: undefined,

  userVopayAccounStatus: undefined,
  userVopayAccountError: undefined,
  userVopayAccountData: undefined,

  userPaymentMethods: undefined,
  userPaymentMethodsStatus: undefined,
  userPaymentMethodsError: undefined,

  organizationOnboardingStatus: undefined,
  organizationOnboardingError: undefined,
  organizationOnboardingData: undefined,

  buildingOnboardingStatus: undefined,
  buildingOnboardingError: undefined,
  buildingOnboardingData: undefined,

  buildingPaymentStatsMonth: undefined,
  buildingPaymentStatsYear: undefined,

  buildingPaymentStatsStatus: undefined,
  buildingPaymentStatsError: undefined,
  buildingPaymentStatsData: undefined
};

export default createReducer(initialState, {
  [updatePaymentData]: (state, { payload }) => ({
    ...state,
    ...payload
  }),

  [clearPaymentData]: (state, { payload }) => ({
    ...initialState,
    buildingPaymentStatsStatus: state.buildingPaymentStatsStatus,
    buildingPaymentStatsData: state.buildingPaymentStatsData,
    buildingPaymentStatsError: state.buildingPaymentStatsError,

    organizationOnboardingStatus: state.organizationOnboardingStatus,
    organizationOnboardingData: state.organizationOnboardingData,
    organizationOnboardingError: state.organizationOnboardingError,

    buildingOnboardingStatus: state.buildingOnboardingStatus,
    buildingOnboardingData: state.buildingOnboardingData,
    buildingOnboardingError: state.buildingOnboardingError,

    buildingPaymentStatsMonth: state.buildingPaymentStatsMonth,
    buildingPaymentStatsYear: state.buildingPaymentStatsYear
  }),

  // Get Grata User

  [requestSuccess(GET_VOPAY_USER)]: (state, { payload }) => ({
    ...state,
    userVopayAccountData: payload,
    userVopayAccounStatus: requestSuccess(GET_VOPAY_USER),
    userVopayAccountError: null
  }),

  [requestPending(GET_VOPAY_USER)]: (state) => ({
    ...state,
    userVopayAccounStatus: requestPending(GET_VOPAY_USER)
  }),

  [requestFail(GET_VOPAY_USER)]: (state, { payload }) => ({
    ...state,
    userVopayAccountData: undefined,
    userVopayAccounStatus: requestFail(GET_VOPAY_USER),
    userVopayAccountError: payload
  }),

  [requestSuccess(GET_VOPAY_USER_PAYMENT_METHODS)]: (state, { payload }) => ({
    ...state,
    userPaymentMethods: Array.isArray(payload) ? payload : [],
    userPaymentMethodsStatus: requestSuccess(GET_VOPAY_USER_PAYMENT_METHODS),
    userPaymentMethodsError: null
  }),

  [requestPending(GET_VOPAY_USER_PAYMENT_METHODS)]: (state) => ({
    ...state,
    userPaymentMethodsStatus: requestPending(GET_VOPAY_USER_PAYMENT_METHODS)
  }),

  [requestFail(GET_VOPAY_USER_PAYMENT_METHODS)]: (state, { payload }) => ({
    ...state,
    userPaymentMethods: [],
    userPaymentMethodsStatus: requestFail(GET_VOPAY_USER_PAYMENT_METHODS),
    userPaymentMethodsError: payload
  }),

  // Organization Onboarding

  [requestSuccess(GET_ORGANIZATION_ONBOARDING_STATUS)]: (state, { payload }) => ({
    ...state,
    organizationOnboardingStatus: requestSuccess(GET_ORGANIZATION_ONBOARDING_STATUS),
    organizationOnboardingData: payload,
    organizationOnboardingError: null
  }),

  [requestPending(GET_ORGANIZATION_ONBOARDING_STATUS)]: (state) => ({
    ...state,
    organizationOnboardingStatus: requestPending(GET_ORGANIZATION_ONBOARDING_STATUS)
  }),

  [requestFail(GET_ORGANIZATION_ONBOARDING_STATUS)]: (state, { payload }) => ({
    ...state,
    organizationOnboardingStatus: requestFail(GET_ORGANIZATION_ONBOARDING_STATUS),
    organizationOnboardingData: undefined,
    organizationOnboardingError: payload
  }),

  // Building Onboarding

  [requestSuccess(GET_BUILDING_ONBOARDING_STATUS)]: (state, { payload }) => ({
    ...state,
    buildingOnboardingStatus: requestSuccess(GET_BUILDING_ONBOARDING_STATUS),
    buildingOnboardingData: payload,
    buildingOnboardingError: null
  }),

  [requestPending(GET_BUILDING_ONBOARDING_STATUS)]: (state) => ({
    ...state,
    buildingOnboardingStatus: requestPending(GET_BUILDING_ONBOARDING_STATUS)
  }),

  [requestFail(GET_BUILDING_ONBOARDING_STATUS)]: (state, { payload }) => ({
    ...state,
    buildingOnboardingStatus: requestFail(GET_BUILDING_ONBOARDING_STATUS),
    buildingOnboardingData: undefined,
    buildingOnboardingError: payload
  }),

  // Get Building Payment Stats

  [requestSuccess(GET_BUILDING_PAYMENT_STATS)]: (state, { payload }) => ({
    ...state,
    buildingPaymentStatsStatus: requestSuccess(GET_BUILDING_PAYMENT_STATS),
    buildingPaymentStatsData: payload,
    buildingPaymentStatsError: null
  }),

  [requestPending(GET_BUILDING_PAYMENT_STATS)]: (state) => ({
    ...state,
    buildingPaymentStatsStatus: requestPending(GET_BUILDING_PAYMENT_STATS)
  }),

  [requestFail(GET_BUILDING_PAYMENT_STATS)]: (state, { payload }) => ({
    ...state,
    buildingPaymentStatsData: undefined,
    buildingPaymentStatsStatus: requestFail(GET_BUILDING_PAYMENT_STATS),
    buildingPaymentStatsError: payload
  }),

  [resetPaymentUserData]: (state) => ({
    ...state,
    userVopayAccountData: undefined,
    userVopayAccounStatus: undefined,
    userVopayAccountError: undefined,
    userPaymentMethods: undefined,
    userPaymentMethodsStatus: undefined,
    userPaymentMethodsError: undefined
  })
});
